export const finalPricingModelData = {
  totalInvestment: 0,
  totalPrepCourseInvestment: 0,
  totalOdtCourseInvestment: 0,
  totalFundamentalCourseInvestment: 0,

  investmentAfterPercentageDiscountOnly: 0,
  discountPercentage: 0,
  perPrepCoursePrice: 0,
  perOdtCoursePrice: 0,
  perFundamentalCoursePrice: 0,

  perCourseDiscountedPrice: 0,
  discountedAmount: 0,
  totalSavedAmount: 0,
  totalSavedAmountPercentage: 0,

  totalCouponValue: 0,
  isMatchApplicable: false,
  matchedPrice: 0,
  todaysPayment: 0,

  hasDownPayedMoreAmount: false,
  downPaymentBalance: 0,

  preBuyBridgePlanAmount: 0,
  perInstallmentPrice: 0,
  numberOfInstallments: 0,
  isPifBasedCommission: false,

  remainingBalanceToCalcInstallments: 0,
  investmentAfterSavings: 0,
  recurringPaymentStartDate: '',
  withSplitDownPayment: '0',

  totalDiscountWithoutPaymentTerms: 0,
  floatInput: '',
};

export type TFinalPricingModelData = typeof finalPricingModelData;
